export const therapistHeroContent = {
  title: "Find an online therapist near you",
  blurb:
    "Meet 1-on - 1 with a compassionate and qualified therapist to get support for your mental health.",
  carePersonType: "therapists",
}
